import React from 'react';
import { Drawer, Skeleton, Space } from 'antd';

const NotificationCardSkeleton = () => <Skeleton active avatar paragraph={{ rows: 2 }} style={{ marginBottom: 16 }} />;

const NotificationSkeleton = ({ visible, onClose }) => {
  return (
    <Drawer title="Notifications" placement="right" onClose={onClose} open={visible} width={400}>
      <Space direction="vertical" style={{ width: '100%' }}>
        {[...Array(5)].map((_, index) => (
          <NotificationCardSkeleton key={index} />
        ))}
      </Space>
    </Drawer>
  );
};

export default NotificationSkeleton;
